export const DOCUMENT_STAGES = {
  DRAFT: "DRAFT",
  INTERNAL_REVIEW: "INTERNAL_REVIEW",
  SENT_FOR_FILLING: "SENT_FOR_FILLING",
  APPROVED: "APPROVED",
  SENT: "SENT",
  DECLINED: "DECLINED",
  COMPLETED: "COMPLETED",
};

export const DOCUMENT_ROLES = {
  ADMIN: "ADMIN",
  USER: "USER",
};



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Constants/index.js